/* tslint:disable */

declare var Object: any;
export interface UsuarioRolInterface {
  "idusuariorol"?: number;
  "idusuario"?: number;
  "idrol"?: number;
  "fechacreacion"?: Date;
}

export class UsuarioRol implements UsuarioRolInterface {
  "idusuariorol": number;
  "idusuario": number;
  "idrol": number;
  "fechacreacion": Date;
  constructor(data?: UsuarioRolInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UsuarioRol`.
   */
  public static getModelName() {
    return "UsuarioRol";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UsuarioRol for dynamic purposes.
  **/
  public static factory(data: UsuarioRolInterface): UsuarioRol{
    return new UsuarioRol(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UsuarioRol',
      plural: 'UsuarioRols',
      path: 'UsuarioRols',
      idName: 'idusuariorol',
      properties: {
        "idusuariorol": {
          name: 'idusuariorol',
          type: 'number'
        },
        "idusuario": {
          name: 'idusuario',
          type: 'number'
        },
        "idrol": {
          name: 'idrol',
          type: 'number'
        },
        "fechacreacion": {
          name: 'fechacreacion',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/lbsdk/models/UsuarioRol.ts